import {
	type AsyncIntlProviderComponent,
	createAsyncIntlProvider,
} from '@atlaskit/intl-messages-provider/async';

import { asyncLanguages } from './async-languages';
import messages from './en';

export const RovoCreditsIntlProvider: AsyncIntlProviderComponent = createAsyncIntlProvider({
	defaultMessages: messages,
	asyncLanguages,
});
